import React from 'react';
import useConnectStripe from '@features/onboarding/hooks/useConnectStripe';
import { Loading } from '@goodfynd/ui';
import { useConfirmationDialog } from '@goodfynd/ui';

import OrderingAlert from './OrderingAlert';
import type { AlertEnableOrderingProps } from './types';

import classes from './OrderingStatusAlert.module.css';

export default function ConnectStripe({
  compact,
  css,
  ctaText = 'Start Accepting Payments',
  text = 'Whether using our online, invoice or POS ordering, Goodfynd makes payments easy and secure by integrating Stripe.',
}: AlertEnableOrderingProps) {
  const { getConfirmation } = useConfirmationDialog();
  const { busy, connectStripe } = useConnectStripe();

  return busy ? (
    <div className={classes.overlay}>
      <Loading />
    </div>
  ) : (
    <OrderingAlert
      busy={busy}
      compact={compact}
      css={css}
      ctaText={ctaText}
      icon="info"
      text={text}
      type="warning"
      buttonClick={async () => {
        if (
          await getConfirmation({
            title: ctaText,
            message:
              'We use Stripe to make sure you get paid on time and to keep all of your personal information secure.',
            confirmButtonText: 'Connect to Stripe',
          })
        ) {
          connectStripe();
        }
      }}
    />
  );
}
